var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M172.3,19.4c-2-7.6-8-13.6-15.6-15.7C143,0,88,0,88,0S33,0,19.2,3.7c-7.6,2-13.5,8-15.6,15.7C0,33.2,0,62,0,62\n\ts0,28.8,3.7,42.6c2,7.6,8,13.6,15.6,15.7C33,124,88,124,88,124s55,0,68.8-3.7c7.6-2,13.5-8,15.6-15.7C176,90.8,176,62,176,62\n\tS176,33.2,172.3,19.4z M70,88.2V35.8L116,62L70,88.2z"}));
}

Youtube.defaultProps = {"version":"1.1","viewBox":"0 0 176 124","xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
